<footer class="site-footer">
  <div class="footer-wave">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none">
      <path
        fill="#f0f4f8"
        fill-opacity="1"
        d="M0,32L60,42.7C120,53,240,75,360,74.7C480,75,600,53,720,42.7C840,32,960,32,1080,37.3C1200,43,1320,53,1380,58.7L1440,64L1440,100L1380,100C1320,100,1200,100,1080,100C960,100,840,100,720,100C600,100,480,100,360,100C240,100,120,100,60,100L0,100Z"
      ></path>
    </svg>
  </div>

  <div class="container">
    <div class="footer-content">
      <div class="footer-logo">
        <div class="logo-container">
          <a routerLink="/" (click)="scrollToTop()" class="footer-logo-link">
            <img src="assets/logo.png" alt="DirtRunner Logo" width="45" height="45" />
            <span class="footer-logo-text">DirtRunner</span>
          </a>
        </div>
        <p>Connecting Truck Drivers with Contractors</p>
        <p class="tagline">
          Find jobs, manage your fleet, and grow your business with our platform.
        </p>
      </div>

      <div class="footer-links-simple">
        <a routerLink="/">Home</a>
        <a routerLink="/about">About</a>
      </div>
    </div>

    <div class="footer-bottom">
      <span>&copy; {{ currentYear }} DirtRunner. All rights reserved.</span>
      <div class="footer-bottom-links">
        <a routerLink="/terms">Terms</a>
        <a routerLink="/privacy">Privacy</a>
        <a routerLink="/eula">EULA</a>
        <a routerLink="/contact">Contact</a>
      </div>
    </div>
  </div>
</footer>
